import { Dispatch, Action } from 'redux';
import { PageState } from 'models/PageState';
import { isEditorialPage } from 'models/EditorialPageModel';
import { getEditorials } from 'services/ApiEditorialService';
import { EditorialLink } from 'models/EditorialLink';
import { ILocation } from 'models/ILocation';
import { createHref, handleServerError, IHref } from 'components/Shared/server';
import { historyPushState } from 'store/history/actions';
import { reduxDispatchEvent } from 'components/Shared/communication';
import { ARTICLELIST_KEY, saveToSessionStorage } from 'utils';

const PREFIX = 'editorial/';
export const SET_EDITORIALS = `${PREFIX}SET_ARTICLES`;
export const ADD_EDITORIALS = `${PREFIX}ADD_ARTICLES`;
export const RESTORE_EDITORIALS = `${PREFIX}RESTORE_ARTICLES`;

export interface SetEditorialsAction extends Action {
  editorials: EditorialLink[];
  nextPage: number;
}

export const addArticlesAction = (data: {
  editorials: EditorialLink[];
  nextPage: number;
}): SetEditorialsAction => ({
  type: ADD_EDITORIALS,
  ...data
});

export const setArticlesAction = (data: {
  editorials: EditorialLink[];
  nextPage: number;
}): SetEditorialsAction => ({
  type: SET_EDITORIALS,
  ...data
});

const cleanLocation = (location: ILocation, page: number): IHref => {
  const url = createHref(location);

  if (page === 1) {
    delete url.search.page;
  } else {
    url.search.page = page.toString();
  }

  void reduxDispatchEvent(historyPushState({ url, state: { forceAllowBack: true } }));
  return url;
};

export const getMoreEditorialsAction = () => (dispatch: Dispatch, getState: () => PageState) => {
  const { currentPage, location } = getState();
  if (!isEditorialPage(currentPage)) {
    return Promise.resolve();
  }
  const { nextPage, group = '', articleFilter } = currentPage;
  const { pathname } = cleanLocation(location, nextPage);

  return getEditorials(nextPage, group, articleFilter)
    .then(({ editorials }) => {
      saveToSessionStorage(ARTICLELIST_KEY, {
        pathname,
        nextPage,
        editorials: [...currentPage.editorials, ...editorials]
      });

      dispatch(addArticlesAction({ nextPage, editorials }));
    })
    .catch(() => {
      handleServerError(dispatch);
    });
};

export const getEditorialsAction =
  (page: number) => (dispatch: Dispatch, getState: () => PageState) => {
    const { currentPage, location } = getState();
    if (!isEditorialPage(currentPage)) {
      return Promise.resolve();
    }
    const { group = '', articleFilter } = currentPage;
    cleanLocation(location, page);

    return getEditorials(page, group, articleFilter)
      .then(({ editorials }) => {
        dispatch(setArticlesAction({ nextPage: page, editorials }));
      })
      .catch(() => handleServerError(dispatch));
  };
